// For Vercel deployment we hit the same origin serverless functions under /api
// You can still override this in env if you later move the backend elsewhere.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

// NOTE: In a frontend app, API keys are always visible to users.
// This env var just makes it configurable for different environments.
export const GOOGLE_BOOKS_API_KEY = process.env.REACT_APP_GOOGLE_BOOKS_API_KEY || 'AIzaSyA6SaT23KNiiA6DnUfUQTvFeyAcQEkwnSU';
